<template>
	<div class="i-adaptive-grid">
		<div class="rows">
			<div class="cols">
				
			</div>
		</div>
	</div>
</template>

<script>
export default {

  name: 'i-adaptive-grid',

  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
</style>